import { ReactNode, useEffect, useRef, useState } from 'react'
import IconClear from 'assets/clear.svg?react'
import IconSearch from 'assets/search.svg?react'
import cn from 'classnames'
import { ButtonIcon } from 'components/extend/ButtonIcon'

import s from './styles.module.less'

type Props = {
  handleSearch: (search: string) => void
  placeholder: string
  searchQuery: string
  className?: string
  iconPoint?: ReactNode
  isInDetailPage?: boolean
  isOrder?: boolean
  isShowSelect?: boolean
  postfix?: React.ReactNode
}

const Search = ({
  isInDetailPage,
  searchQuery,
  placeholder,
  handleSearch,
  postfix,
  isOrder,
  iconPoint,
  className,
  isShowSelect
}: Props) => {
  const [isFocused, setIsFocused] = useState(false)
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  const handleClear = () => {
    handleSearch('')
  }

  useEffect(() => {
    if (isShowSelect) {
      handleFocus()
    }
  }, [isShowSelect])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.blur()
    }
  }, [])

  return (
    <div
      className={cn(
        s.searchBlock,
        isFocused ? s.searchBlock_focused : s.searchBlock,
        isInDetailPage ? s.searchBlockInDetailPage : '',
        className
      )}
    >
      {isOrder ? iconPoint : <IconSearch className={s.icon} size="xs" />}
      <input
        ref={inputRef}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={isInDetailPage}
        className={cn(s.input, isOrder ? s.ml24 : '')}
        onBlur={handleBlur}
        onChange={(e) => handleSearch(e.target.value)}
        onFocus={handleFocus}
        placeholder={placeholder}
        type="text"
        value={searchQuery}
      />
      <div className={s.icons}>
        {searchQuery.length > 0 ? <ButtonIcon className={s.clear} icon={IconClear} onClick={handleClear} /> : ''}
        {postfix}
      </div>
    </div>
  )
}

export default Search
